import * as React from "react";
import { forwardRef } from "react";
const SvgIconChecked = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 1.5, y: 1.5, width: 21, height: 21, rx: 2.5, fill: "#5265FF", stroke: "#182231" }), /* @__PURE__ */ React.createElement("path", { d: "M16.5802 7.58002L17.9902 9.00002L9.99023 17L5.99023 13.01L7.41023 11.6L9.99023 14.17L16.5802 7.58002Z", fill: "white" }));
const ForwardRef = forwardRef(SvgIconChecked);
export { ForwardRef as ReactComponent };
